<template>
  <v-footer class="footer" dark>
    <v-container class="mt-8">
      <v-row>
        <v-col lg="6" md="6" sm="6" xl="6" class="d-flex flex-column align-center">
          <div class="d-flex">
            <div class="mb-5" style="width: 90px; height: 90px; background-color: white; border-radius: 60%;">
              <img src="@assets/images/imager_10038 1.png" alt="" width="90px" />
            </div>
            <div class="pl-8">
              <ul>
                <li class="mb-3"><span style="color: white" class="title-text">CƠ QUAN CHỦ QUẢN
                  </span>
                  <span style="color: white"></span>
                </li>
                <li >
                  <b style="color: #B3B6B7">
                    TRUNG TÂM THÔNG TIN VÀ DỮ LIỆU MÔI TRƯỜNG -TỔNG CỤC MÔI TRƯỜNG
                  </b>
                </li>
                <li>Chịu trách nhiệm chính: Ông <b style="color: #B3B6B7">Nguyễn Văn Thuỳ</b> - Giám Đốc Trung Tâm</li>
              </ul>
            </div>
          </div>
        </v-col>
        <v-col lg="6" md="6" sm="6" xl="6" class="d-flex flex-column align-center">
          <div style="margin-left: 0px">
            <div>
              <div class="mb-4 title-text">LIÊN HỆ</div>
              <ul>
                <li>
                  <div>
                    <div class="d-flex">
                      <v-icon class="mr-2">mdi-map-marker-outline</v-icon>
                      <div>Trụ sở liên cơ quan Bộ Tài nguyên và Môi trường</div>
                    </div>
                    <div class="ml-4 pl-4">
                      Số 83, Nguyễn Chí Thanh, Đống Đa, Hà Nội
                    </div>
                  </div>
                </li>
                <li>
                  <v-icon class="mr-2">mdi-phone</v-icon> (0243) 5527919
                  <span class="pl-4">

                    Fax: (0243) 8728294
                  </span>
                </li>
                <li>
                  <v-icon class="mr-2">mdi-email-open-outline</v-icon>
                  thongtindulieumt@monre.gov.vn
                </li>
              </ul>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>
<script>
export default {
  data: () => ({}),
}
</script>
<style scoped>
ul {
  padding-left: 0;
}

li {
  list-style: none;
  color: #909896;
  margin-bottom: 8px;
}

.green-color-text {
  color: #b5cec8;
}

.footer {
  background-color: #073430;
  background-repeat: no-repeat;
  min-height: 230px;
  background-position: left bottom, top right;
  background-image: url('~@assets/images/footerLeft.svg'),
    url('~@assets/images/footerRight.svg');
}

.title-text {
  font-weight: bold;
  color: white;
  text-transform: uppercase;
}
</style>
